export const ruleTemplates = [
    `input%class%[type=radio]:checked {
        %checked%
    }`,
];
